import { Component, Input } from '@angular/core';
import type { NavigationExtras } from '@angular/router';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { GenericLinkDirective } from '@core/jss-utils';
import { TrackImpressionDirective } from '@analytics/events';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { BasicContentVariantInheritableComponent } from '../../variants/basic-content-variant.inheritable.component';
import { BasicContentPartialHeadingComponent } from '../basic-content-partial-heading/basic-content-partial-heading.component';

@Component({
  selector: 'wl-basic-content-partial-top-between[content][settings][context]',
  templateUrl: './basic-content-partial-top-between.component.html',
  styleUrls: [
    './basic-content-partial-top-between.component.ed.scss',
    './basic-content-partial-top-between.component.essent.scss',
  ],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    NgClass,
    RichTextWrapperComponent,
    GenericLinkDirective,
    TrackImpressionDirective,
    JssModule,
    BasicContentPartialHeadingComponent,
  ],
})
export class BasicContentPartialTopBetweenComponent extends BasicContentVariantInheritableComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showIconInHeader = true;

  public navigationExtras: NavigationExtras = {
    queryParamsHandling: 'merge',
  };
}
